var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitorHow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 160,
    viewBox: "0 0 180 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_848_173)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.302 115.062H65.4136V156.166H114.302V115.062Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.433 156.168H62.2822V160H117.433V156.168Z",
    fill: "#343435"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.683 0H8.03223C3.59615 0 0 3.59527 0 8.03025V122.236C0 126.671 3.59615 130.266 8.03223 130.266H171.683C176.119 130.266 179.716 126.671 179.716 122.236V8.03025C179.716 3.59527 176.119 0 171.683 0Z",
    fill: "#343435"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.683 7.54688H8.03223V97.4178H171.683V7.54688Z",
    fill: "#C0E3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.198 123.954H131.517V74.4414H162.243L169.198 81.3952L169.198 123.954Z",
    fill: "#0B121E"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M171.684 121.466H134.002V71.9531H164.728L171.684 78.907L171.684 121.466Z",
    fill: "#F7F7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.927 95.1914H140.789V97.6353H159.927V95.1914Z",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.927 90.3398H140.789V92.7837H159.927V90.3398Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M159.927 85.4883H140.789V87.9322H159.927V85.4883Z",
    fill: "#D9D9D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.927 80.6367H140.789V83.0806H159.927V80.6367Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148.584 70.8466C148.584 68.3705 146.576 66.3633 144.099 66.3633C141.622 66.3633 139.615 68.3705 139.615 70.8466V73.7905C139.615 76.2665 141.622 78.2738 144.099 78.2738C146.576 78.2738 148.584 76.2665 148.584 73.7905V70.8466Z",
    fill: "#FC3500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142.576 74.4427C142.947 74.6626 143.37 74.7828 143.801 74.7914C144.762 74.7914 145.06 74.179 145.052 73.7197C145.043 72.9457 144.346 72.614 143.623 72.614H143.206V72.0527H143.623C144.167 72.0527 144.856 71.7719 144.856 71.117C144.856 70.6748 144.575 70.2835 143.886 70.2835C143.49 70.2948 143.105 70.422 142.78 70.6494L142.585 70.1051C143.015 69.8251 143.518 69.6773 144.031 69.6797C145.12 69.6797 145.613 70.3262 145.613 70.9981C145.608 71.2964 145.505 71.5848 145.321 71.8196C145.137 72.0544 144.881 72.2228 144.593 72.2994V72.3163C144.934 72.3659 145.247 72.5367 145.473 72.7974C145.7 73.0582 145.825 73.3915 145.826 73.7368C145.826 74.6212 145.137 75.3952 143.81 75.3952C143.306 75.4016 142.809 75.2724 142.372 75.0211L142.576 74.4427Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_848_173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179.716,
    height: 160,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorHow);
export default __webpack_public_path__ + "static/media/MonitorHow.ba6ce52429de191eb354a20029022e1a.svg";
export { ForwardRef as ReactComponent };